// Fictitious Conforama stores until Conforama sends its store list: externalId is the external_id of the Estaly store.
export const CONFO_STORES = [
  { externalId: "CONFO_PARIS_NATION", label: "CONFORAMA PARIS NATION" },
  { externalId: "CONFO_LYON_SAINT_PRIEST", label: "CONFORAMA LYON SAINT-PRIEST" },
  { externalId: "CONFO_MARSEILLE_PLAN_DE_CAMPAGNE", label: "CONFORAMA MARSEILLE PLAN DE CAMPAGNE" },
];
